import { useQuery } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { patientsApi } from '../api/patientsApi';

export function usePatientSearch(q?: string, sort?: string) {
  return useQuery({
    queryKey: keys.patient.search(q ?? '', sort),
    queryFn: ({ signal }) => patientsApi.search(q, sort, { signal }),
    staleTime: 60_000,
  });
}
